import { ApiError } from './types';

export const apiErrorMessage = (
  error: Error | null,
  fallback = 'Unexpected error. Please try again.'
): string | null => {
  if (!error) return null;
  if (error instanceof ApiError) return error.errors[0]?.message ?? error.message ?? fallback;
  return fallback;
};

export const fieldErrorsFromApiError = (error: Error | null): Record<string, string> => {
  if (!(error instanceof ApiError)) return {};
  const out: Record<string, string> = {};
  for (const e of error.errors) {
    if (e.field) {
      const key = e.field.replace(/^body\./, '').replace(/\[(\d+)\]/g, '.$1');
      out[key] = e.message;
    }
  }
  return out;
};
